/* 工具 */
//获取所有叶子节点
export function getAllLeaf(data) {
  let result = []
  let indexs = [];
  let deviceWidth = 0;

  function getLeaf(data) {
    data.forEach(item => {
      if (!item.children || item.children.length == 0) {
        if (!indexs.includes(item.id)) {
          indexs.push(item.id);
          deviceWidth = deviceWidth + getGroupWidth(item);
          item.x = deviceWidth;
          result.push(item)
        }
      } else {
        getLeaf(item.children)
      }
    })
  }
  getLeaf(data)
  return result
}
//遍历所有节点
export function getAllNode(data) {
  let result = [];
  let indexs = [];

  function getNode(data, fdata) {
    if (data instanceof Array) {
      data.forEach((item, index) => {
        if (item.children) {
          //正序
          getNode(item.children, item);
          //倒序
          //加载层级关系
          if (!fdata.id) {
            fdata.id = 0;
          }
          item.fid = fdata.id;
          if (!indexs.includes(item.id)) {
            indexs.push(item.id);
            item.index = index;
            result.push(item);
          }
        }
      })
    }
  }
  getNode(data, data);
  return result;
}

export function delTreeNode(node){
  let result = [];
  function check(d){
    return d.style!=301;
  }
   function getAllNode(data){
     if(data instanceof Array){
       data.forEach((item,index)=>{
         if(item.children.length){
           getAllNode(item.children);
         }
         data.filter(check);
       })
     }
     result = data;
   }
   getAllNode(node);
   return result;
}
//获取节点的高度
export function getParentNodeInfo(list, element, length) {
  let result = [];
  let height = 0;
  let width = 0;
  let tmpElement = element;
  list = getArraySort(list, 'level', 'desc');
  list.forEach((item, index) => {
    if (element.fid == item.id) {
      height += getDeviceHeight(item);
      element = item;
    }
  })
  width = tmpElement.groupSizes.split(',');
  width = parseInt(width[0]);
  tmpElement.y = height;
  length = length + width;
  tmpElement.groupWidth = width;
  return tmpElement;
}

//获取组件总长度
export function getTotalLength(data) {
  let len = 0;
  for (let i = 0; i < data.children.length; i++) {
    let group = data.children[0].groupSizes.split(',');
    len += parseInt(group[0]);
  }
  return len;
}
//获取文字的宽度
export function getTextWidth(text, canvasObj) {
  canvasObj.font = '12px 微软雅黑';
  return canvasObj.measureText(text).width;
}
//获取图片的宽度和高度
export function getImgInfo(url) {
  var img = new Image();
  img.src = url;
  return {
    width: img.width,
    height: img.height
  }
}
//根据对象属行分组
export function getArrayGroup(list, attr) {
  function groupBy(array, f) {
    var groups = {};
    array.forEach(function(o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function(group) {
      return groups[group];
    });
  }
  var sorted = groupBy(list, function(item) {
    return [item[attr]];
  });
  return sorted
}
//获取当前设备的高度
export function getDeviceHeight(item) {
  let totalLength = 0;
  //上线的高度
  if (item.lineUp && item.lineUp.linetype > 0) {
    totalLength += item.lineUp.linelength
  }
  //下线的高度
  if (item.lineDown && item.lineDown.linetype > 0) {
    totalLength += item.lineDown.linelength
  }
  //设备的高度
  if (item.imageSizes) {
    let sizes = item.imageSizes;
    sizes = sizes.split(',');
    totalLength += parseInt(sizes[1]);
  }
  return totalLength;
}
//对象数组排序
export function getArraySort(list, name, sort) {
  function sortid(a, b) {
    if (sort == 'desc') {
      return b[name] - a[name];
    }
    if (sort == 'asc') {
      return a[name] - b[name];
    }
  }
  return list.sort(sortid);
}
//获取当前层级的高度
export function getLayerGroupTop(list, level) {
  let layer = [];

  list.forEach((item, index) => {
    let totalLength = 0;
    //上线的高度
    if (item[0] && item[0].lineup) {
      totalLength += item[0].lineup.linelength
    }
    //下线的高度
    if (item[0] && item[0].linedown) {
      totalLength += item[0].linedown.linelength
    }
    //设备的高度
    if (item[0] && item[0].imageSizes) {
      let sizes = item[0].imageSizes;
      sizes = sizes.split(',');
      totalLength += parseInt(sizes[1]);
    }
    layer.push({
      name: item[0].name,
      level: item[0].level,
      totalLength: totalLength
    });
  })
  if (layer[0].level > 1) {
    layer = layer.reverse();
  }

  return layer;
}
//获取组宽度
export function getGroupWidth(item) {
  let sizes = [];
  if (item.groupSizes) {
    sizes = item.groupSizes.split(',');
  }
  return parseInt(sizes[0]);
}
//获取所有叶子节点的总宽度
export function getLeafWidth(data) {
  let layerData = getAllLeaf(data);
  let deviceWidth = 0;
  layerData.forEach(item => {
    deviceWidth = deviceWidth + getGroupWidth(item);
  });
  return deviceWidth;
}
//获取树结构的高度
export function getTreeHeight(data) {
  let result = [];
  let offsetHeight = 50;

  function a(data) {
    data.forEach((item, index) => {
      if (index == 0) {
        result.push({
          image: item.image,
          imageSizes: item.imageSizes,
          level: item.level,
          lineDown: item.lineDown,
          lineUp: item.lineUp,
          fields:item.fields
        })
      }
      if (item.children && item.children.length) {
        a(item.children)
      }
    })
  }
  a(data);
  let height = 0;
  let size = 0;
  let level = [];
  let levelArray = [];
  result.forEach(item => {
    if (level.indexOf(item.level) == -1) {
      level.push(item.level);
      levelArray.push(item);
      if (item.image && item.imageSizes) {
        size = parseInt(item.imageSizes.split(',')[1]);
        height += size;
      }
      if (item.lineUp && item.lineUp.linelength>0) {
        height += item.lineUp.linelength;
      }
      if (item.lineDown && item.lineDown.linelength>0) {
        height += item.lineDown.linelength;
      }
      if(item.fields && item.fields.length>0){
        let len = item.fields.length;
        if(item.fields[0][0].position=='down'){
          height += len*24;
        }
      }
    }
  })
  return height + offsetHeight;
}
//自适应屏幕
export function autosize(id) {
  window.addEventListener('load', adaptation);
  window.addEventListener('resize', adaptation);

  function adaptation() {
    var w = document.body.clientWidth;
    var h = document.body.clientHeight;
    var nw = 1920;
    var nh = 1080;
    var left, top, scale;
    if (w / h > nw / nh) {
      scale = h / nh;
      top = 0;
      left = (w - nw * scale) / 2;
    } else {
      scale = w / nw;
      left = 0;
      top = (h - nh * scale) / 2;
    }
    document.getElementById(id).setAttribute('style', 'transform: scale(' + scale + ')');
  }
}
//获取屏幕信息
export function getScreenInfo() {
  let screen = {};
  screen.bodyClientWidth = {
    name: "网页可见区域宽",
    value: document.body.clientWidth
  };

  screen.bodyClientHeight = {
    name: "网页可见区域高",
    value: document.body.clientHeight
  };

  screen.bodyOffsetWidth = {
    name: "网页可见区域宽(包括边线和滚动条的宽)",
    value: document.body.offsetWidth
  };

  screen.bodyOffsetHeight = {
    name: "网页可见区域高(包括边线的宽)",
    value: document.body.offsetHeight
  };

  screen.bodyScrollWidth = {
    name: "网页正文全文宽",
    value: document.body.scrollWidth
  };

  screen.bodyScrollHeight = {
    name: "网页正文全文高",
    value: document.body.scrollHeight
  };

  screen.bodyScrollTop = {
    name: "网页被卷去的高(ff)",
    value: document.body.scrollTop
  };

  screen.documentElementScrollTop = {
    name: "网页被卷去的高(ie)",
    value: document.documentElement.scrollTop
  };

  screen.bodyScrollLeft = {
    name: "网页被卷去的左",
    value: document.body.scrollLeft
  };

  screen.windowScreentop = {
    name: "网页正文部分上",
    value: window.screenTop
  };

  screen.windowScreenLeft = {
    name: "网页正文部分左",
    value: window.screenLeft
  };

  screen.windowScreenHeight = {
    name: "屏幕分辨率的高",
    value: window.screen.height
  };

  screen.windowScreenWidth = {
    name: "屏幕分辨率的宽",
    value: window.screen.width
  };
  return screen;
}
//设置显示比率，设计稿尺寸
export function setScreenZoom(size) {
  let screen = getScreenInfo();
  let width = screen.bodyClientWidth.value;
  width = width * (1 / size);

  document.body.style.zoom = width;
}
//随机颜色数据
export function getRandomColor() {
  return '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).substr(-6);
}
//获取当月第一天
export function getFirstDay() {
  let date = new Date();
  date.setDate(1);
  let cTime = new Date(new Date(date).toLocaleDateString()).getTime();
  //将时间戳转换成时间格式
  let date1 = new Date(cTime);
  let year = date1.getFullYear();
  let month = date1.getMonth() + 1;
  let day = date1.getDate();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  let ddate = year + '-' + month + '-' + day;
  return ddate;
}
export default {
  getAllLeaf,
  getAllNode,
  getTotalLength,
  getTextWidth,
  getImgInfo,
  getArrayGroup,
  getLayerGroupTop,
  getParentNodeInfo,
  getDeviceHeight,
  getLeafWidth,
  getGroupWidth,
  getScreenInfo,
  setScreenZoom,
  getRandomColor,
  getTreeHeight,
  delTreeNode,
  getFirstDay
}



// WEBPACK FOOTER //
// ./src/utils/tools.js